import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getCategories() {
    return RetailerApiClient.get('category').then(response => {
      return response
    })
  },
  getSubCategories(categoryId) {
    return RetailerApiClient.get('category/' + categoryId + '/sub-categories').then(response => {
      return response
    })
  },
  getAllProducts(query) {
    return RetailerApiClient.get('products', { params: query }).then(response => {
      return response
    })
  },
  searchProduct(params) {
    return RetailerApiClient.get('products', { params }).then(response => {
      return response
    })
  },
  getProducts(subCategoryId) {
    return RetailerApiClient.get('sub-category/' + subCategoryId + '/products').then(response => {
      return response
    })
  },
  getProductsByCategory(categoryId) {
    return RetailerApiClient.get('categories/' + categoryId + '/products')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSalesChannelsProducts(salesChannelId) {
    return RetailerApiClient.get('sales-channel/' + salesChannelId + '/products').then(response => {
      return response
    })
  },
  getProductById(productId) {
    return RetailerApiClient.get('products/' + productId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getMobileProductsByCategory(categoryId) {
    return RetailerApiClient.get(`mobile-products-by-category/${categoryId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
